function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "back"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M5.52825 11.6667H25.7026C25.9701 11.6667 26.2267 11.7545 26.4159 11.9108C26.605 12.067 26.7113 12.279 26.7113 12.5C26.7113 12.721 26.605 12.933 26.4159 13.0893C26.2267 13.2456 25.9701 13.3334 25.7026 13.3334H5.52825C5.26072 13.3334 5.00415 13.2456 4.81498 13.0893C4.62581 12.933 4.51953 12.721 4.51953 12.5C4.51953 12.279 4.62581 12.067 4.81498 11.9108C5.00415 11.7545 5.26072 11.6667 5.52825 11.6667Z",
  fill: "#565656"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M5.54898 12.5425L11.9399 19.0206C12.0846 19.1673 12.1659 19.3663 12.1659 19.5737C12.1659 19.7812 12.0846 19.9802 11.9399 20.1269C11.7952 20.2736 11.599 20.356 11.3944 20.356C11.1897 20.356 10.9935 20.2736 10.8488 20.1269L3.91388 13.0956C3.84212 13.023 3.78519 12.9368 3.74634 12.8419C3.7075 12.747 3.6875 12.6453 3.6875 12.5425C3.6875 12.4397 3.7075 12.338 3.74634 12.2431C3.78519 12.1481 3.84212 12.0619 3.91388 11.9894L10.8488 4.95812C10.9935 4.81142 11.1897 4.729 11.3944 4.729C11.599 4.729 11.7952 4.81142 11.9399 4.95812C12.0846 5.10481 12.1659 5.30378 12.1659 5.51124C12.1659 5.7187 12.0846 5.91767 11.9399 6.06437L5.54898 12.5425Z",
  fill: "#565656"
}));

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.5b54b24c1a239ce0b81a37ec2caf3192.svg";
export { ForwardRef as ReactComponent };